import React, {useEffect, useState} from "react";
import {Toaster, toast} from "sonner";
import {
    Button, ButtonGroup, Card, CardBody, CardHeader, Checkbox, CheckboxGroup, Chip,
    Divider,
    Input,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow, Tooltip, User
} from "@nextui-org/react";
import {useLocation, useNavigate} from "react-router-dom";
import {FaEdit, FaEye, FaPlusCircle, FaRegPauseCircle, FaRegPlayCircle} from 'react-icons/fa';
import {createMachine, createProduct} from "../API";

export default function MachinesDetails() {
    const initData = {
        idmachine_last: "",
        cells: 0,
        columns: 0,
        description: "",
        idmachine:"",
        name:"",
        rows:0,
        background:"#000000",
        new: true,
    }
    const [machine, setMachine] = useState(initData);
    const [image, setImage] = useState('');
    const [positions, setPositions] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const {data} = location.state || {};
    const navigate = useNavigate();

    const columns = [
        {name: "MAQUINA", uid: "idmachine"},
        {name: "CODIGO", uid: "code"},
        {name: "COMPUERTA", uid: "iddoor"},
        {name: "LUZ", uid: "light"},
        {name: "PRINCIPAL", uid: "main_door"},
        {name: "SEQUENCIA", uid: "sequence"},
        {name: "PADRE", uid: "parent"},
        {name: "ESTADO", uid: "status"},
        {name: "DESCRIPCION", uid: "description"},
        {name: "ACCIONES", uid: "actions"},
    ];

    const status = {
        "CE": {"color": "primary", "name": "Cerrado"},
        "AB": {"color": "warning", "name": "Abierto"},
        "ER": {"color": "danger", "name": "Error"},
    }

    useEffect(() => {
        if (data !== undefined) {
            setMachine(data);
            setPositions(data.positions);
            setMachine((prev) => ({
                ...prev,
                idmachine_last: data.idmachine,
            }));
        }
    }, []);


    function OnChange(e) {
        setMachine({...machine, [e.target.name]: e.target.value});
    }

    const renderCell = React.useCallback((position, columnKey) => {
        const cellValue = position[columnKey];
        switch (columnKey) {
            case "actions":
                return (
                    position.new ?? (
                        <div className="relative flex items-center gap-2">
                            <Button onClick={() => openDetails(position)} color="transparent" isIconOnly>
                                <Tooltip content="Editar producto">
                                  <span className="text-lg text-default-400 cursor-pointer active:opacity-50">
                                    <FaEdit/>
                                  </span>
                                </Tooltip>
                            </Button>
                        </div>
                    )
                );

            case "main_door":
                return (
                    <div className="relative flex items-center gap-2">
                        <p>{position.main_door ? "SI" : "NO"}</p>
                    </div>
                );

            case "status":
                return (
                    <div className="relative flex items-center gap-2">
                    <Chip color={status[position.status].color}>{status[position.status].name}</Chip>
                </div>);
            default:
                return cellValue;
        }
    }, []);

    function openDetails(data) {
        navigate("/dashboard/positions-details", {state: {data}});
    }

    const doorIdentifiers = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const cellIdentifiers = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];

    function generateCells(e) {

        if (!machine.rows || !machine.columns || !machine.cells) {
            toast.error("Cargar los campos necesarios.")
            return;
        }

        if (machine.rows <= 0 || machine.columns <= 0 || machine.cells <= 0) {
            toast.error("Los filas/columnas/celdas deben ser superior a 0.")
            return;
        }

        setPositions([]);
        const mainDoors = machine.rows * machine.columns;
        const newPositions = [];
        let iddoor = 0;
        let light = 0;
        for (let i = 0; i < mainDoors; i++) {
            iddoor++;
            light++;
            const value = {
                "idmachine": machine.idmachine,
                "idposition": i,
                "iddoor": iddoor,
                "code": `${i+1}${cellIdentifiers[0]}`,
                "description": "",
                "main_door": true,
                "parent": null,
                "idparent": 0,
                "sequence": 0,
                "status": "CE",
                "light": light,
                "new": true
            }
            newPositions.push(value);

            for (let j = 0; j < machine.cells - 1; j++) {
                iddoor++;
                const cellIn = {
                    "idmachine": machine.idmachine,
                    "idposition": `${i+1}${cellIdentifiers[j + 1]}`,
                    "iddoor": iddoor,
                    "code": `${i+1}${cellIdentifiers[j + 1]}`,
                    "description": "",
                    "main_door": false,
                    "idparent": i,
                    "parent": `${i+1}${cellIdentifiers[0]}`,
                    "sequence": j + 1,
                    "status": "CE",
                    "light": light,
                    "new": true
                }
                newPositions.push(cellIn);
            }
        }

        setPositions(newPositions);

    }

    async function OnSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        if(!!image)
            formData.append('file', image);

        const body = {
            'machine': machine,
            'positions': positions
        }
        console.log(body);
        formData.append('item', JSON.stringify(body));
        const res = await createMachine(formData);

        if (res === 200)
            toast.success("Producto creada correctamente. ✅")
        else
            toast.error("Algo ha salio mal. 🙁")
        setLoading(false);
    }

    return (
        <>
            <Toaster richColors/>
            <h1 className="pb-5 text-2xl">{data === undefined ? "Nueva maquina" : "Detalle maquina"} </h1>
            <div className="flex flex-col gap-4">
                <form className="flex w-full flex-wrap gap-4" onSubmit={OnSubmit}>
                    <h2 className="text-xl text-warning">General</h2>

                    <Input
                        type="text"
                        label="Codigo"
                        labelPlacement="outside"
                        value={machine.idmachine}
                        onChange={OnChange}
                        name="idmachine"
                        isRequired
                        required
                    />
                    <Input
                        type="text"
                        label="Nombre"
                        labelPlacement="outside"
                        value={machine.name}
                        onChange={OnChange}
                        name="name"
                        isRequired
                        required
                    />
                    <Input
                        type="text"
                        label="Descripcion"
                        labelPlacement="outside"
                        value={machine.description}
                        onChange={OnChange}
                        name="description"
                    />
                    <h2 className="pt-5 text-xl text-warning">Extras</h2>
                    <div className="flex w-full flex-wrap md:flex-nowrap gap-4">
                        <Input
                            type="color"
                            label="Color de fondo"
                            placeholder="Cargar color"
                            labelPlacement="outside"
                            name="background"
                            value={machine.background}
                            onChange={OnChange}
                        />
                        <Input
                            type="File"
                            label="Imagen"
                            labelPlacement="outside"
                            placeholder="Cargar imagen"
                            accept="image/*"
                            onChange={e =>{
                                const file = e.target.files[0];
                                if(file)
                                    setImage(file);
                            }}
                        />
                    </div>

                    <h2 className="pt-5 text-xl text-warning">Formacion</h2>
                    <Input
                        type="number"
                        label="Filas"
                        labelPlacement="outside"
                        name="rows"
                        value={machine.rows}
                        onChange={OnChange}
                        maxLength={10}
                        minLength={1}
                        isRequired
                        required
                    />
                    <Input
                        type="number"
                        label="Columnas"
                        labelPlacement="outside"
                        name="columns"
                        value={machine.columns}
                        onChange={OnChange}
                        maxLength={10}
                        minLength={1}
                        isRequired
                        required
                    />
                    <Input
                        type="number"
                        label="Celdas"
                        name="cells"
                        labelPlacement="outside"
                        value={machine.cells}
                        onChange={OnChange}
                        maxLength={5}
                        minLength={1}
                        isRequired
                        required
                    />
                    <Divider orientation="horizontal"/>
                    <h2 className="pt-5 text-xl text-warning">Posiciones</h2>

                    <Table aria-label="Posiciones">
                        <TableHeader columns={columns}>
                            {(column) => (
                                <TableColumn key={column.uid} align={column.uid === "actions" ? "center" : "start"}>
                                    {column.name}
                                </TableColumn>
                            )}
                        </TableHeader>
                        <TableBody items={positions}>
                            {(item) => (
                                <TableRow key={item.idposition}>
                                    {(columnKey) => <TableCell>{renderCell(item, columnKey)}</TableCell>}
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <div className="container">
                        <ButtonGroup className="p-3">
                            {
                                positions && positions.length === 0 ? (
                                    <Button onClick={() => generateCells()}>Generar Posiciones</Button>) : null
                            }
                            <Button isDisabled={positions.length === 0} color="success"
                                    type="submit"
                                    isLoading={loading}>{data === undefined ? "Crear" : "Actualizar"}</Button>
                        </ButtonGroup>

                    </div>

                </form>

            </div>
        </>
    );
}
